import React, { useState, useCallback } from 'react';
import { Box, Button, LinearProgress, Alert } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { filesAPI } from '../../services/api';

export default function FileUpload({ onFilesUploaded, maxFiles = 5, accept }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState('');

  const handleUpload = useCallback(async (e) => {
    const selected = Array.from(e.target.files);
    if (!selected.length) return;
    setError('');
    setUploading(true);
    setProgress(0);

    try {
      const formData = new FormData();
      selected.forEach(f => formData.append('files', f));
      const { data } = await filesAPI.uploadMultiple(formData);
      const uploaded = Array.isArray(data) ? data : [data];
      onFilesUploaded?.(uploaded);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al subir el archivo');
    } finally {
      setUploading(false);
      setProgress(100);
      e.target.value = '';
    }
  }, [onFilesUploaded]);

  return (
    <Box>
      {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
      <Button
        component="label"
        variant="outlined"
        startIcon={<CloudUpload />}
        disabled={uploading}
        size="small"
      >
        {uploading ? 'Subiendo...' : 'Adjuntar Archivos'}
        <input type="file" hidden multiple accept={accept} onChange={handleUpload} />
      </Button>
      {uploading && <LinearProgress variant="determinate" value={progress} sx={{ mt: 1, borderRadius: 1 }} />}
    </Box>
  );
}
